module.exports = __webpack_public_path__ + "static/media/aluminio-placa-liso.b20d482f.jpg";